import { render, staticRenderFns } from "./LandCover.vue?vue&type=template&id=7704cbae"
import script from "./LandCover.vue?vue&type=script&lang=js"
export * from "./LandCover.vue?vue&type=script&lang=js"
import style0 from "./LandCover.vue?vue&type=style&index=0&id=7704cbae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports